<div [hidden]="!visible">
    <div class="modal d-block">
        <div class="historyBorder" (click)="closeModal()"></div>
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border_shadow">
                <div class="modal-header">
                    <h8 class="modal-title d-flex justify-content-between lato" cvLocalizedText langSection="Users" langKey="Add_User_Title">
                        Add New User
                    </h8>
                    <button type="button" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="closeModal()">
                        <svg class="icon-16">
                            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                        </svg>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row h-100 mr-3">
                        <!-- Profile picture and Bio -->
                        <div class="col-4 mt-4 plr-4">
                            <div class="h-100 w-100 d-inline-flex flex-column align-items-center">
                                <div id="profilePic_new" class="profilePic" (click)="uploadingImg = true"></div>
                                <div>
                                    <p>
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Add_Profile_Pic">
                                            Add Profile Pic
                                        </span>
                                    </p>
                                </div>
                                <cv-image-upload *ngIf="uploadingImg" (croppedImage)="updateUserImage($event)" (close)="uploadingImg = false;"></cv-image-upload>
                                <div>
                                    <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Bio">
                                        Bio:
                                    </span>
                                    <textarea class="form-control bio" cols="50" rows="5" cvLocalizedPlaceholder langSection="Users"
                                              langKey="Bio" [(ngModel)]="userProfile.Bio"> </textarea>
                                </div>
                            </div>
                        </div>
                        <!-- User deatils -->
                        <div class="col-7 offset-1 h-100 userDetails">
                            <div class="mb-4">
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Username">
                                            Username
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <input type="text" class="form-control w-100" cvLocalizedPlaceholder langSection="Users"
                                               langKey="Username" [(ngModel)]="user.LoginName"
                                               [ngClass]="{'requiredInput':user.LoginName==null || user.LoginName.trim()==''}" />
                                    </div>
                                    <div class="col-2">
                                        <span class="requiredText" cvLocalizedText langSection="Users" langKey="Required"
                                              *ngIf="user.LoginName==null || user.LoginName.trim()==''">
                                            Required
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="First_Name">
                                            First Name
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <input type="text" class="form-control w-100" cvLocalizedPlaceholder langSection="Users"
                                               langKey="First_Name" [(ngModel)]="user.FirstName" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Last_Name">
                                            Last Name
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <input type="text" class="form-control w-100" cvLocalizedPlaceholder langSection="Users"
                                               langKey="Last_Name" [(ngModel)]="user.LastName" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Email_Details">
                                            Email
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <input type="text" class="form-control requiredInput w-100" cvLocalizedPlaceholder langSection="Users"
                                               langKey="Email_Details" [(ngModel)]="user.Email"
                                               [ngClass]="{'requiredInput':user.Email==null || user.Email.trim()==''}" />
                                    </div>
                                    <div class="col-2">
                                        <span class="requiredText" cvLocalizedText langSection="Users" langKey="Required"
                                              *ngIf=":user.Email==null || user.Email.trim()==''">
                                            Required
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Languages">
                                            Languages
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <select class="form-control w-100" [(ngModel)]="userLang">
                                            <option disabled class="placeholder_option" value="" cvLocalizedText langSection="Users"
                                                    langKey="Select">
                                                Select
                                            </option>
                                            <option *ngFor="let opt of languages" [value]="opt.Value">{{opt.Value=="NoneSet" ? "English (Company Default)": opt.Value}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-4">
                                <div class="row" *ngIf="timezoneInfo?.defaultCompanyTimeZone != 'Not Set'">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Time_Zone">
                                            Time Zone
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <select class="form-control w-100" [(ngModel)]="user.TimeZoneInfoName">
                                            <option value="Not Set" cvLocalizedText langSection="Users" langKey="Default"
                                                    title="timezoneInfo.defaultCompanyTimeZone">
                                                Company Default
                                            </option>
                                            <option *ngFor="let opt of timezoneInfo?.availableTimeZones" [ngValue]="opt">{{opt}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Role_Title">
                                            Role
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <select class="form-control w-100" [(ngModel)]="user.ProfileName">
                                            <option *ngFor="let opt of listProfileDTOs" [value]="opt.ProfileName">{{opt.ProfileName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Type">
                                            Type
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <select class="form-control w-100" [(ngModel)]="user.RelatedGroupTypeName" (change)="onRelatedGroupTypeChange($event)">
                                            <option disabled class="placeholder_option" value=""
                                                    cvLocalizedText langSection="Users" langKey="Select">
                                                Select
                                            </option>
                                            <option *ngFor="let opt of baseGroupTypes; index as index;" [value]="opt">{{opt}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Level_Title">
                                            Level
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <select class="form-control w-100" [(ngModel)]="user.RelatedGroupLevelName" (change)="onRelatedGroupLevelChange($event)">
                                            <option disabled class="placeholder_option" value="" cvLocalizedText langSection="Users"
                                                    langKey="Select">
                                                Select
                                            </option>
                                            <option *ngFor="let opt of groupLevelOptions" [value]="opt.GroupTypeName">{{opt.GroupTypeName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <span class="color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Linked_Data_Group">
                                            Linked Data Group
                                        </span>
                                    </div>
                                    <div class="col-7">
                                        <select class="form-control requiredInput w-100" [(ngModel)]="user.RelatedGroupName"
                                                [ngClass]="{'requiredInput': user.RelatedGroupID == null || user.RelatedGroupID < 0}"
                                                (change)="onLDGroupChange($event)">
                                            <option disabled class="placeholder_option" value="" cvLocalizedText langSection="Users"
                                                    langKey="Select">
                                                Select
                                            </option>
                                            <option *ngFor="let opt of ldGroupOptions" [value]="opt.GroupName">{{opt.GroupName}}</option>
                                        </select>
                                    </div>
                                    <div class="col-2 requiredText" *ngIf="user.RelatedGroupID == null || user.RelatedGroupID <0">
                                        Required
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="row ">
                                    <div class="col-3">
                                        <label class="form-check-label color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Quality_Notification">
                                            Quality Notification
                                        </label>
                                    </div>
                                    <div class="col-7">
                                        <input class="form-check-input" type="checkbox" [(ngModel)]="user.ReceiveAlerts" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <label class="form-check-label color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Performance_Alert">
                                            Performance Alert
                                        </label>
                                    </div>
                                    <div class="col-7">
                                        <input class="form-check-input" type="checkbox" [(ngModel)]="user.ReceivePOAlerts" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <label class="form-check-label color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Active">
                                            Active
                                        </label>
                                    </div>
                                    <div class="col-7">
                                        <input class="form-check-input" type="checkbox" [(ngModel)]="user.Active" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-3">
                                        <label class="form-check-label color-valyrianSteel" cvLocalizedText langSection="Users" langKey="Multi_Factor_Title">
                                            Multi-Factor Authentication
                                        </label>
                                    </div>
                                    <div class="col-7">
                                        <input id="newUserRequireMfa" class="form-check-input" type="checkbox" [(ngModel)]="user.MultiFactorRequired" />
                                        <label for="newUserRequireMfa" class="form-check-label ml-4" cvLocalizedText langSection="Security_Admin" langKey="Required">Required</label>
                                    </div>
                                </div>
                                <div class="row" *ngIf="permissions?.ShouldShowSSO">
                                    <div class="col-3">
                                        <label class="form-check-label color-valyrianSteel" cvLocalizedText langSection="Users" langKey="SSO_Subject_Identifier">
                                            SSO Subject Identifier
                                        </label>
                                    </div>
                                    <div class="col-7">
                                        <input class="form-control w-100" type="text" [(ngModel)]="user.ExternalID" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer mt-0">
                    <button type="button" class="btn btn-primary" (click)="saveUser()" [disabled]="saveDisabled()"
                            cvLocalizedText langSection="Users" langKey="Save_Button">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
